export default __webpack_public_path__ + "static/media/miguel-lopes-38.ef70eb57.jpg";